/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for sorting the data:
 *   * DATE_STATE : the alarm creation date
 *   * LAST_VALUE_DATETIME : the alarm last update date
 *   * TAG : the tag name
 *   * MESSAGE : the description of the alarm
 *   * TICKET_NUMBER : the ticket number linked
 *   * STATION_NAME : the station name
 *   * STATION_CODE : the station code
 */
export enum AlarmSortFieldName {
  DATE_STATE = 'DATE_STATE',
  LAST_VALUE_DATETIME = 'LAST_VALUE_DATETIME',
  TAG = 'TAG',
  MESSAGE = 'MESSAGE',
  TICKET_NUMBER = 'TICKET_NUMBER',
  STATION_NAME = 'STATION_NAME',
  STATION_CODE = 'STATION_CODE'
}
